import { Vehicle } from 'core/models/vehicle';
import { DriveCommand, ControlMode, DriveMode, EmergencyMode } from 'core/models/drive';

export function updateVehicleStatus(currentStatus: Vehicle.Status, delta: Partial<Vehicle.Status>) {
    return Object.entries(delta).reduce((acc, [key, value]) => value !== undefined
        ? { ...acc, [key]: value }
        : acc, currentStatus);
}

export function driveCommandToStatusDelta(command: Partial<DriveCommand>): Partial<Vehicle.Status> {
    const { controlMode, emergency, ...rest } = command;
    return {
        mode: controlMode === ControlMode.Auto ? DriveMode.Auto
            : DriveMode.Remote,
        emergency: emergency !== EmergencyMode.Normal,
        ...rest,
    };
}
